import Panel from '../components/panel'
import {Button} from '../components/button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../state/consts.ts";
import ModalInfoGEG from "./modal_info_geg.tsx";
import { ModalLinkBEG, ModalLinkGEG } from "../components/modal_link.tsx";
import GEGInfo from "../components/geg_info.tsx";
import { round_to_1000 } from "../functions.ts";
import { useEffect } from "react";

export default function ModalFensterFuture() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const close_menu = useStore((state) => state.close_menu);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const init_property_if_undefined = useStore((state) => state.init_property_if_undefined);
    const financial_plan_dummy = useStore((state)=>state.financial_plan_dummy);

    const fenster_future = useStore((state)=>state.fenster_future);    
    const api_get_costs = useStore((state)=>state.api_get_costs);
    useEffect(()=>{
        api_get_costs("window",fenster_future);
    },[fenster_future]);
        
  return (<Panel >
            <h1>Welche neuen Fenster sind geplant?</h1>
            <GEGInfo GEG={1.3} BEG={0.95}/>
            <PropertyInput type="fenster_future"/>
            <PropertyInput type="fenster_kosten" placeholder_prefix={"optional ca."} placeholder_override={round_to_1000(financial_plan_dummy["window"].total_costs)  + " €"}/>
            <PropertyInput type="fenster_isfp"/>
            
            <Button label={MODAL_CONFIRM_BUTTON_LABEL} onClick={()=>{
                close_menu();
                init_property_if_undefined("fenster_future");
                api_recalculate();
                pop_modal();
            }}/>
         </Panel>)
}

